module.exports = __webpack_public_path__ + "static/img/img_tip1.e86a56f5.png";